import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import {
  savePermision,
  updatePermission,
} from "../../features/admin/RoleSlice";
import { toast } from "react-toastify";
const roleSchema = Yup.object().shape({
  permissionName: Yup.string()
    .trim()
    .min(3, "Tên phân quyền phải ít nhất 3 ký tự")
    .required("Tên phân quyền không được để trống"),
});

export default function PermissionModal({ role, isOpen, onClose }) {
  const dispatch = useDispatch();
  const { status: saveStatus, error } = useSelector((state) => state.roles);
  const [permissionName, setPermissionName] = useState("");
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (role) {
      setPermissionName(role.permissionName || "");
    } else {
      setPermissionName("");
    }
  }, [role]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    let data = {
      permissionName: permissionName,
    };
    try {
      await roleSchema.validate(data, { abortEarly: false });
      if (role?.id) {
        await dispatch(
          updatePermission({ dataUpdate: data, id: role.id })
        ).unwrap();
        toast.success("Cập nhật phân quyền thành công!");
      } else {
        await dispatch(savePermision(data)).unwrap();
        toast.success("Tạo phân quyền thành công!");
      }
      onClose();
    } catch (error) {
      if (error instanceof Yup.ValidationError) {
        const formErrors = {};
        error.inner.forEach((err) => {
          formErrors[err.path] = err.message;
        });
        setErrors(formErrors);
      } else {
        toast.error("Đã xảy ra lỗi! Vui lòng thử lại.");
        console.error("Lỗi khi lưu phân quyền:", error);
      }
    }
  };
  if (!isOpen) return null;
  return (
    <div className="fixed inset-0 bg-gray-500 bg-opacity-50 flex justify-center items-center">
      <div className="bg-base-100 p-6 rounded-md w-96">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-semibold mb-4">
            {role?.id ? "Chỉnh sửa phân quyền" : "Tạo phân quyền"}
          </h2>
          <button
            onClick={onClose}
            className="px-4 py-2 border rounded-md shadow-sm text-sm font-medium text-base-700 bg-base-100 hover:bg-base-200"
          >
            X
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <label htmlFor="permissionName" className="block text-sm font-medium">
            Tên phân quyền<i className="text-red-600"> *</i>
          </label>
          <input
            type="text"
            placeholder="Nhập phân quyền"
            value={permissionName}
            onChange={(e) => {
              setErrors((prev) => ({ ...prev, permissionName: "" }));
              setPermissionName(e.target.value);
            }}
            className="input input-bordered w-full mb-4"
          />
          {errors.permissionName && (
            <p className="text-red-500 text-sm">{errors.permissionName}</p>
          )}

          <div className="flex justify-end space-x-4">
            <button type="button" className="btn btn-sm" onClick={onClose}>
              Hủy
            </button>
            <button
              type="submit"
              className="btn btn-primary btn-sm"
              disabled={saveStatus === "loading"}
            >
              {saveStatus === "loading"
                ? "Đang lưu..."
                : role?.id
                ? "Cập nhật"
                : "Tạo"}
            </button>
          </div>
          {error && (
            <p className="text-red-500 text-sm mt-2">
              Đã xảy ra lỗi: {error.message}
            </p>
          )}
        </form>
      </div>
    </div>
  );
}
